import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';
import { formElementRequiredText } from 'consts/errors/forms';
import { formFields } from 'consts/form/formFields';
import { rspoRegExp } from 'consts/regexps';

export const RspoNumberInputElement = (props: AppFormItemProps) => (
    <AppFormItem
        label="Numer RSPO"
        name={formFields.rspoNumber}
        rules={[
            { required: true, message: formElementRequiredText },
            {
                pattern: rspoRegExp,
                message: 'Niepoprawny numer RSPO',
                required: true,
            },
        ]}
        {...props}
    >
        <AppInput autoComplete="off" placeholder="Podaj numer RSPO" />
    </AppFormItem>
);
